import React from "react";
import { connect } from "react-redux";
import "./FelixSignUp.scss";

const CommissionJunction = (props) => {
  window.location.href="https://forexhero.ai"
  return (
    <></>
  );
};

export default connect(null, {  })(CommissionJunction);
